import React, { Component } from "react";
import "./FaucetInfo.css";
import axios from "axios";
import NumberFormat from "react-number-format";
import config from "react-global-configuration";

class FaucetInfo extends Component {
  // Adds a class constructor that assigns the initial state values:
  constructor() {
    super();
    this.state = {
      faucetinfo: null
    };
  }
  // This is called when an instance of a component is being created and inserted into the DOM.
  componentWillMount() {
    axios
      .get(window.location.href + "faucetinfo")
      .then(response => {
        //response.data.etherscanlink = response.data.etherscanroot + "/address/" + response.data.account;
        response.data.etherscanlink = response.data.etherscanroot + "address/" + response.data.account;
        this.setState({ faucetinfo: response.data });
        localStorage.setItem("faucetinfo", response.data);
      })
      // Catch any error here
      .catch(error => {
        console.log(error);
      });
  }

  componentDidMount() {
    if (!navigator.onLine) {
      try {
        let f = JSON.parse(localStorage.getItem("faucetinfo"));
        this.setState({ faucetinfo: f });
      } catch (e) {
        //
      }
    }
  }

  // The render method contains the JSX code which will be compiled to HTML.
  render() {
    if (!this.state.faucetinfo) return null;
    return (
      <section className="section">
        <div className="content has-text-centered has-text-weight-light">
          <h3>About Faucet</h3>
          <p>
            This faucet sends {this.state.faucetinfo.payoutamountinether} GO
            every {this.state.faucetinfo.payoutfrequencyinsec} seconds. You can
            register your account in our queue. You may make a request once per 24 Hours.  Max queue size is currently{" "}
            {this.state.faucetinfo.queuesize}.
          </p>
          <p>We send Test GO from account{" "}
            <a target="_new" href={this.state.faucetinfo.etherscanlink}>
              {this.state.faucetinfo.account}
            </a>
            ( balance{" "}
            <NumberFormat
              value={Math.floor(this.state.faucetinfo.balance)}
              displayType={"text"}
              thousandSeparator={true}
              suffix={" GO"}
            />
            ).
          </p>
          <p>
            If you need additional Test GO or have any questions please reach out to <a href="mailto:dev@gochain.io">dev@gochain.io</a>
          </p>
        </div>
      </section>
    );
  }
}

export default FaucetInfo;



// WEBPACK FOOTER //
// ./src/FaucetInfo/FaucetInfo.js